














































































import { defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { DownloadIcon, LoadingIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon } from 'tdesign-icons-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { downloadByLink } from '@/renderer/scripts/utils/tools/index';
import { IS_BROWSER } from '@/common/constant/platform';
import { httpUrl } from '@/renderer/scripts/http';

import { getDownloadPath, downloadUrlFileToLocal } from '@/renderer/scripts/utils/download/downloadHelper';
import importHandler from '../compositions/importHandler';

export default defineComponent({
  components: {
    DownloadIcon,
    LoadingIcon,
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    uploadInfo: {
      type: Object,
      default: {},
    },
    methods: {
      type: Object,
      default: {},
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const uploadInfoVal = computed(() => props.uploadInfo);
    const uploadMethods = computed(() => props.methods);
    const { templateColumns, templateRecords } = importHandler();
    const methods = {
      // 下载模板
      async downloadTemplate() {
        const url = store.getters.onlyPasswordLogin
          ? httpUrl.staticCDNURLMap.userPasswordTemplateUrl
          : httpUrl.staticCDNURLMap.userTemplateUrl;
        if (IS_BROWSER) {
          downloadByLink(url, i18n_t('用户导入模板.xlsx'));
        } else {
          const downloadPath = await getDownloadPath();
          if (!downloadPath) return;
          downloadUrlFileToLocal({
            url,
            downloadPath,
            downloadName: i18n_t('用户导入模板.xlsx'),
            autoRename: true,
            openDirAfterDownload: true,
          });
        }
      },
      // 点击导入
      async onConfirm() {
        context.emit('submit');
      },
    };
    return {
      innerShow,
      templateColumns,
      templateRecords,
      uploadInfoVal,
      ...methods,
      uploadMethods,
    };
  },
});
